module.exports = __webpack_public_path__ + "static/media/rssapp.a2256b7e.png";